/* * 地图图层树 * @module components/layertree/LayerTree * @desc 用于图层树 *
<template>
  <div>
    <div id="search">
      <Input v-model="monomerName" placeholder="请输入单体代码">
        <template #suffix>
          <Icon type="ios-search" @click="handleSubmit" />
        </template>
      </Input>
    </div>
    <div class="mainContent">
      <div class="headerTitle">
        <div class="headerTitle_left">资源筛选</div>
        <div class="headerTitle_right"></div>
      </div>
      <div class="seachContent" v-if="flagSearch">
        <div class="selectCodeConetnt">
          <!-- <div class="colTitle">
          <img src="../../../assets/zyLevel.png" alt="" class="imgCal" />
          <div class="titleText">资源分类</div>
        </div> -->
          <div class="oneLevel">
            <div class="leftTitle">
              <img
                src="../../../../static/image/menu.png"
                height="15px"
                width="15px"
                style="margin-bottom: -3px"
              />
              资源分类
            </div>
            <div class="leftTitle">
              <img
                src="../../../../static/image/line.png"
                height="15px"
                width="15px"
                style="margin-left: -5px; margin-bottom: -3px"
              />主类
            </div>
            <ul class="contentFl">
              <li
                v-for="(nav, index) in oneLevelArr"
                :class="nav.flag ? 'lis activeLis' : 'lis'"
                :key="index"
                @click="selectOneLeavl(index)"
                :title="nav.title"
              >
                {{ nav.title }}
              </li>
            </ul>
          </div>
          <div class="oneLevel">
            <div class="leftTitle">
              <img
                src="../../../../static/image/line.png"
                height="15px"
                width="15px"
                style="margin-left: -5px;margin-bottom: -3px"
              />亚类
            </div>
            <ul class="contentFl">
              <li
                v-for="(navItem, index) in twoLevelArr"
                :class="navItem.flag ? 'listow activeLis' : 'listow'"
                :key="index"
                @click="selectSecond(index)"
                :title="navItem.value"
              >
                {{ navItem.value }}
              </li>
            </ul>
          </div>

          <div class="oneLevel">
            <div class="leftTitle">
              <img
                src="../../../../static/image/line.png"
                height="15px"
                width="15px"
                style="margin-left: -5px;margin-bottom: -3px"
              />基本类型
            </div>
            <ul class="contentFl">
              <li
                v-for="(navItem, index) in threeLeveArr"
                :class="navItem.flag ? 'listow activeLis' : 'listow'"
                :key="index"
                @click="selectThird(index)"
                :title="navItem.value"
              >
                {{ navItem.value }}
              </li>
            </ul>
          </div>
          <div class="oneLevel">
            <div class="leftTitle">
              <img
                src="../../../../static/image/Classification.png"
                height="15px"
                width="15px"
                style=" margin-right:5px;margin-bottom: -3px"
              />资源分级
            </div>
            <ul class="contentFl">
              <li
                v-for="(navItem, index) in primaryLevelArr"
                :class="navItem.flag ? 'listow activeLis' : 'listow'"
                :key="index"
                @click="selectResource(index)"
              >
                {{ navItem.title }}
              </li>
            </ul>
          </div>
        </div>
        <div class="btnsCal">
          <Button @click="handleReset" class="leftBtns">重置</Button>
          <Button type="primary" class="rightBtns" @click="handleSubmit">查询</Button>
        </div>
      </div>
      <div class="resultCal" v-else>
        <div class="fanCal" @click="reverseSearch">
          <Icon type="md-arrow-back" />
        </div>
        <ul class="resultUls" v-if="dataList.length > 0">
          <li
            class="resultLis"
            v-for="(codeItem, indexk) in dataList"
            :key="indexk"
            :class="selectIndex == indexk ? 'selectActiviti' : null"
            @click="selectPoint(indexk)"
          >
            <div class="leftCal">
              <img
                :src="codeItem.imgUrl ? codeItem.imgUrl : '../../../../static/img/loaderror.png'"
                alt=""
                class="imgUrlCal"
              />
            </div>
            <div class="rightCal">
              <div class="titleCode">{{ codeItem.monomerName }}</div>
              <div class="jddjCode">景点等级：{{ codeItem.scenicSpotGrade }}</div>
              <div class="dxdwCode">景点位置：{{ codeItem.administrativeLocation }}</div>
              <div class="jdmsCode">性质特征：{{ codeItem.appearance }}</div>
            </div>
          </li>
        </ul>
        <div class="pageCal" v-if="dataList.length > 0">
          <Page
            :total="totalNumber"
            :current="searchParam.pageNumber"
            :page-size="searchParam.pageSize"
            class="page"
            show-sizer
            @on-change="changePage"
            @on-page-size-change="changePageSize"
          />
        </div>
        <div class="noData" v-else>
          <img src="../../../../static/img/noDataImg.png" alt="" class="noDataImg" />
          <div class="noText">~ 暂无数据 ~</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import menuLayerTree from './menuLayerTree';
export default menuLayerTree;
</script>
<style lang="less" scoped>
.selectActiviti {
  background-color: #4f7ac9;
  color: #fff;
  .imgUrlCal {
    background-color: #fff;
  }
}
#search {
  position: absolute;
  top: 10px;
  left: 290px;
  height: 34px;
  width: 260px;
  z-index: 99;
  font-size: 12px;
  line-height: 22px;
  text-align: center;
  background-color: #fff;
  border: 1px solid #eee;
  border-radius: 2px;
}
.mainContent {
  // width: 100%;
  // height: 100%;
  height: 100%;
  width: 380px;
  position: absolute;
  right: 0;
  top: 0.2rem;
  display: flex;
  flex-direction: column;
  font-family: 'Microsoft YaHei';
  color: #000000;
  background: #fff;
  z-index: 999;
  .headerTitle {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 10px;
    height: 55px;
    border-bottom: 1px solid #eaeaea;
    .headerTitle_left {
      font-size: 20px;
      font-family: 'Microsoft YaHei';
      font-weight: bold;
      color: #333333;
      line-height: 55px;
    }
  }
  .topSearch {
    width: 100%;
    height: 40px;
    border-bottom: 1px solid #f3f3f3;
    .inputCal {
      width: 100%;
    }
  }
  .selectCodeConetnt {
    width: 100%;
    height: 65vh;
    overflow: hidden auto;
    margin-top: 10px;
    // padding: 0 25px;
    .colTitle {
      width: 100%;
      // border-bottom: 1px solid #f3f3f3;
      height: 40px;
      display: flex;
      align-items: center;
      color: #333;
      font-size: 14px;
      .imgCal {
        margin: 0 10px 0 10px;
      }
    }
    .oneLevel {
      width: 100%;
      min-height: 50px;
      display: flex;
      padding: 5px;
      flex-direction: column;

      .leftTitle {
        margin-bottom: 14px;
        margin-left: 14px;
        width: 85px;
        color: #333;
        font-size: 14px;
        font-weight: 500;
        font-family: 'Microsoft YaHei';
      }
      .contentFl {
        flex: 1;
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        .lis {
          min-width: 11rem;
          height: 3.6rem;
          line-height: 3.6rem;
          border: 1px solid #f2f2f2;
          text-align: center;
          cursor: pointer;
          border-radius: 5px;
          margin-bottom: 5px;
          font-size: 1.2rem;
          padding: 0 5px;
          margin-left: 14px;
          font-weight: 400;
          font-size: 13px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowra;
        }
        .listow {
          width: 11rem;
          height: 3.6rem;
          line-height: 3.6rem;
          border: 1px solid #f2f2f2;
          text-align: center;
          cursor: pointer;
          border-radius: 5px;
          margin-bottom: 5px;
          font-size: 1.2rem;
          padding: 0 10px;
          margin-left: 14px;
          font-size: 13px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .activeLis {
          background: #1353c8;
          color: #fff;
        }
      }
    }
  }
  .btnsCal {
    width: 100%;
    height: 93px;
    display: flex;
    justify-content: center;
    align-items: center;
    // border-top: 1px solid #f2f2f2;
    .leftBtns {
      background-color: #cbcbcb;
      width: 120px;
      height: 38px;
      border-radius: 0;
      margin-right: 10px;
    }
    .rightBtns {
      width: 120px;
      height: 38px;
      border-radius: 0;
      margin-left: 10px;
      background-color: #0075ff;
    }
  }
  .resultCal {
    width: 100%;
    height: calc(~'100% - 105px');
    .fanCal {
      position: absolute;
      right: 5px;
      top: 2px;
      width: 35px;
      font-size: 35px;
      color: #2d8cf0;
      cursor: pointer;
    }
    .resultUls {
      width: 100%;
      height: 98%;
      overflow-y: auto;
      .resultLis {
        padding: 10px;
        height: 102px;
        border-bottom: 1px solid #f2f2f2;
        display: flex;
        cursor: pointer;
        .leftCal {
          width: 100px;
          height: 100%;
          border: 1px solid #f2f2f2;
          object-fit: contain;
          border-radius: 3px;
          overflow: hidden;
          .imgUrlCal {
            width: 100px;
            height: 100%;
            object-fit: contain;
          }
        }
        .rightCal {
          width: 60%;
          padding-left: 10px;
          .titleCode {
            width: 100%;
            font-size: 14px;
            color: #333333;
            font-weight: bold;
            overflow: hidden; //超出隐藏
            white-space: nowrap; //不折行
            text-overflow: ellipsis; //溢出显示省略号
            margin-bottom: 5px;
          }
          .jddjCode {
            width: 100%;
            font-size: 12px;
            overflow: hidden; //超出隐藏
            white-space: nowrap; //不折行
            text-overflow: ellipsis; //溢出显示省略号
          }
          .dxdwCode {
            width: 100%;
            font-size: 12px;
            overflow: hidden; //超出隐藏
            white-space: nowrap; //不折行
            text-overflow: ellipsis; //溢出显示省略号
          }
          .jdmsCode {
            width: 100%;
            font-size: 12px;
            overflow: hidden; //超出隐藏
            white-space: nowrap; //不折行
            text-overflow: ellipsis; //溢出显示省略号
          }
        }
      }
    }
    .noData {
      padding: 30px 20px;
      display: flex;
      justify-content: center;
      flex-direction: column;
      .noDataImg {
        width: 100px;
        height: 100px;
        align-items: center;
        margin-left: 33%;
      }
      .noText {
        width: 100%;
        text-align: center;
      }
    }
    .pageCal {
      width: 100%;
      height: 50px;
      border-top: 1px solid #f2f2f2;
      overflow: auto;
      .page {
        margin-top: 6px;
        height: 50px;
        justify-content: center;
      }
    }
  }
}
/deep/::-webkit-scrollbar {
  width: 0px;
}
/deep/.ivu-page.mini .ivu-page-item {
  min-width: 1.4rem;
}
/deep/.ivu-page {
  display: flex;
}
/deep/.ivu-page-item a {
  margin: 0 0.3rem;
}
</style>



// WEBPACK FOOTER //
// src/components/leftmenu/layers/menuLayerTree.vue